import { render, staticRenderFns } from "./agent-request-info.vue?vue&type=template&id=74c1544b&scoped=true&"
import script from "./agent-request-info.vue?vue&type=script&lang=js&"
export * from "./agent-request-info.vue?vue&type=script&lang=js&"
import style0 from "./agent-request-info.vue?vue&type=style&index=0&id=74c1544b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1544b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
